import appStore from '../utils/state';
import type { CartState } from '../types';
import gsap from 'gsap';

export default class CartPage extends HTMLElement {
  private quantity: number = 0;
  private isEmpty: boolean = false;

  private empty: HTMLDivElement | null = null;
  private form: HTMLFormElement | null = null;
  private goToFormTl: gsap.core.Timeline | null = null;
  private goToEmptyTl: gsap.core.Timeline | null = null;

  private unsubscribeFromCartUpdated: (() => void) | null = null;

  private onCartUpdatedBound = this.onCartUpdated.bind(this);

  connectedCallback(): void {
    this.quantity = parseInt(this.dataset.quantity ?? '0', 10);
    this.isEmpty = this.quantity === 0;

    this.empty = this.querySelector('[data-cart-page-ref="empty-cart"]');
    this.form = this.querySelector('[data-cart-page-ref="form"]');

    this.subscribe();
  }

  subscribe(): void {
    this.unsubscribeFromCartUpdated = appStore.subscribeKey('cart', this.onCartUpdatedBound);
  }

  unsubscribe(): void {
    if (this.unsubscribeFromCartUpdated) {
      this.unsubscribeFromCartUpdated();
    }
  }

  onCartUpdated(cart: CartState): void {
    const wasEmpty = this.isEmpty;
    this.isEmpty = cart.data?.item_count === 0;

    if (wasEmpty !== this.isEmpty) {
      if (this.isEmpty) {
        this.goToEmptyState();
      } else {
        this.goToFormState();
      }
    }
  }

  goToFormState(): void {
    if (this.goToFormTl) {
      this.goToFormTl.kill();
    }
    this.goToFormTl = gsap.timeline();
    this.goToFormTl.set(this.empty, { autoAlpha: 0, duration: 0.3, ease: 'power2.out' }, 0);
    this.goToFormTl.to(this.form, { autoAlpha: 1, duration: 0.3, ease: 'power2.out' }, 0.4);
  }

  goToEmptyState(): void {
    if (this.goToEmptyTl) {
      this.goToEmptyTl.kill();
    }

    this.goToEmptyTl = gsap.timeline();
    this.goToEmptyTl.set(this.form, { autoAlpha: 0, duration: 0.3, ease: 'power2.out' }, 0);
    this.goToEmptyTl.to(this.empty, { autoAlpha: 1, duration: 0.3, ease: 'power2.out' }, 0.4);
  }

  disconnectedCallback(): void {
    this.unsubscribe();
  }
}

customElements.define('cart-page', CartPage);
